export default {
  methods: {
    scrollTop(top = 0) {
      (document.documentElement
        && document.documentElement.scrollTop
        && (document.documentElement.scrollTop = top))
      ||
      (document.body
        && document.body.scrollTop
        && (document.body.scrollTop = top))
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/scrollTop.js